import React, {Component} from 'react';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import { Table } from 'semantic-ui-react'

class ReportDipartimentiTabularRowView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let c = this.props.item;

        return (
            <Table.Row key={this.props.i}>
                <Table.Cell collapsing={true} textAlign="left">{c.idDipartimento}</Table.Cell>
                <Table.Cell textAlign="left">{c.nome}</Table.Cell>
                <Table.Cell textAlign="left">{c.idOrganizzazione.nomeCompleto}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.piva} {c.cfisc}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.indirizzo}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.cap}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.citta}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.provincia}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.stato}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.email}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.pec}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.web}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.cellulare}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.tel1}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.tel2}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">{c.fax}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">
                    {c.creatoIl ?  <span><LocalDate data={c.creatoIl} /> <LocalTime data={c.creatoIl} /></span> : "?"}
                    &nbsp;{c.creatoDa ? c.creatoDa.username : '?'}</Table.Cell>
                <Table.Cell collapsing={true} textAlign="left">
                    {c.modificatoIl ?  <LocalDate data={c.modificatoIl } /> : '?'}
                    &nbsp;
                    {c.modificatoIl ?  <LocalTime data={c.modificatoIl } /> : null}
                    &nbsp;{c.modificatoDa ? c.modificatoDa.username : '?'}</Table.Cell>
                <Table.Cell textAlign="left">{c.note}</Table.Cell>
            </Table.Row>
        )
    }
}




export default ReportDipartimentiTabularRowView;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportDipartimentiTabularRowView.js
 **/